// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiPromptController from "./ai_prompt_controller"
application.register("ai-prompt", AiPromptController)

import BroadcastFormController from "./broadcast_form_controller"
application.register("broadcast-form", BroadcastFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import EndpointAccessPickerController from "./endpoint_access_picker_controller"
application.register("endpoint-access-picker", EndpointAccessPickerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeroSyncController from "./hero_sync_controller"
application.register("hero-sync", HeroSyncController)

import LandingViewportController from "./landing_viewport_controller"
application.register("landing-viewport", LandingViewportController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import SetupTabsController from "./setup_tabs_controller"
application.register("setup-tabs", SetupTabsController)

import WhiteLabelPreviewController from "./white_label_preview_controller"
application.register("white-label-preview", WhiteLabelPreviewController)

import TagsInputController from "./tags_input_controller"
application.register("tags-input", TagsInputController)

import TestPanelController from "./test_panel_controller"
application.register("test-panel", TestPanelController)

import TestPageController from "./test_page_controller"
application.register("test-page", TestPageController)

import TestEndpointWizardController from "./test_endpoint_wizard_controller"
application.register("test-endpoint-wizard", TestEndpointWizardController)

import TemplateBuilderController from "./template_builder_controller"
application.register("template-builder", TemplateBuilderController)

import LiveInboxController from "./live_inbox_controller"
application.register("live-inbox", LiveInboxController)

import OtpVerificationController from "./otp_verification_controller"
application.register("otp-verification", OtpVerificationController)

import TocScrollSpyController from "./toc_scroll_spy_controller"
application.register("toc-scroll-spy", TocScrollSpyController)
